module.exports = __webpack_public_path__ + "static/media/logo-aiga.77af13ba.svg";